export const conversationalAssistantText = (value: unknown): string =>
	String(value || '')
		.split(/(https?:\/\/[^\s]+)/g)
		.map((part) =>
			/^https?:\/\//i.test(part)
				? part
				: part.replace(/\*\*([^*\n]+)\*\*/g, '$1').replace(/__([^_\n]+)__/g, '$1'),
		)
		.join('');

export default conversationalAssistantText;
